import React from 'react';
import ConnectedProjectList from '../containers/ConnectedProjectList';
import { ProjectType } from '../domain/Project';

const AllProjects: React.FC = () => {
  return (
    <>
      <ConnectedProjectList filters={{ type: ProjectType.PROJECT }} />
    </>
  );
};

export default AllProjects;
